import { createPermissions, hasRole } from 'cesg-shared';
import { UserRole } from 'cesg-shared/dist/models';
import type { GetMeResponse } from 'cesg-shared/dist/models/schemas/auth-schema';
import type { MaybeRefOrGetter } from 'vue';
import { computed, toValue } from 'vue';

interface UseOverviewPermissionsProps {
  projectId: MaybeRefOrGetter<string>;
  user: MaybeRefOrGetter<GetMeResponse>;
}

export type OverviewPermissions = ReturnType<
  typeof useOverviewPermissions
>['mode'];

export const useOverviewPermissions = ({
  projectId,
  user,
}: UseOverviewPermissionsProps) => {
  const mode = computed(() => {
    const permissionTo = createPermissions(toValue(projectId), toValue(user));
    const canEdit =
      hasRole(UserRole.CESG, toValue(user)) && permissionTo.edit.overview;
    return {
      projectMetaData: canEdit ? 'normal' : 'read-only',
      projectNotes: canEdit ? 'edit' : 'read-only',
      defaultReviewerSelector: canEdit ? 'edit' : 'read-only',
      afterMarketTable: canEdit ? 'edit' : 'read-only',
      debitNorms: canEdit ? 'edit' : 'read-only',
    } as const;
  });

  return { mode };
};
